// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1vlyp","footer":"ChangeClinic_footer__dIj0T"};